<template>
  <div class="main">

    <div style="position: fixed;right:3%;top:50%;z-index: 999;">
      <img  @click="onRetuen" src="https://pxsp.iceriverbj.com/%E8%BF%94%E5%9B%9E%20%281%29.png" width="70rem" alt="">
    </div>
    <div class="main_image">
      <div v-for="(item, index) in details.url_arr" :key="index" class="image-container">
        <template v-if="ongetExtension(item)">FF
          <VideoPlayer :item="item" :image="details.cover_img"></VideoPlayer>
        </template>
        <template v-else>
          <el-image :src="item">
            <template #error>
              <i class="el-icon-picture-outline"></i>
            </template>
          </el-image>
        </template>
      </div>
      <div class="image_" :style="{ height: elementHeight + 100 + 'px' }"></div>
    </div>
    <div class="Well_details" v-if="$route.query.event_id != 1885">

      <div class="Well_details_info" :class="'x' + $route.query.event_id">
        <div class="Well_details_info_head" :class="'a' + $route.query.event_id">
          <div class="image" @click="onRetuen" v-if="Params.id">
            <img src="../assets/image/right.png" alt="" />
          </div>
          <div class="title">
            {{ details.title }}
          </div>
        </div>
        <div class="Well_details_info_content">
          <div class="View">
            <div class="image">
              <img src="../assets/image/opacity_people.png" alt="" />
            </div>
            <div class="title">作者：</div>
            <div class="content">{{ details.author }}</div>
          </div>
          <div class="View">
            <div class="image">
              <img src="../assets/image/opacity_city.png" alt="" />
            </div>
            <div class="title">单位：</div>
            <div class="content">
              {{ details.company }}
            </div>
          </div>
        </div>
      </div>

      <div class="Well_details_Sort" @click.stop="onisUpvote(details.id)">
        <div class="Sort_img">
          <img src="../assets/image/Sort.png" alt="" v-if="UpvoteIdList.includes(details.id)" />
          <img src="../assets/image/SortcloneDetail.png" alt="" v-else />
        </div>
        <div style="margin-left: 0.5rem">{{ details.upvote }}</div>
      </div>
    </div>
  </div>
</template>

<script>
function onBridgeReady() {
  WeixinJSBridge.call('hideOptionMenu');
}
if (typeof WeixinJSBridge == 'undefined') {
  if (document.addEventListener) {
    document.addEventListener('WeixinJSBridgeReady', onBridgeReady, false);
  } else if (document.attachEvent) {
    document.attachEvent('WeixinJSBridgeReady', onBridgeReady);
    document.attachEvent('onWeixinJSBridgeReady', onBridgeReady);
  }
} else {
  onBridgeReady();
}
import { getLiteratureInfoNew } from '../api/api';
import VideoPlayer from './VideoPlayer.vue';
import Home from '../mixins/home';
export default {
  mixins: [Home],
  components: {
    VideoPlayer,
  },
  data() {
    return {
      details: {},
      api: process.env.VUE_APP_BASE_API,
      imageUrls: [],
      Params: {
        ListId: this.$route.query.ListId,
        event_id: this.$route.query.event_id,
        id: this.$route.query.id,
      },
      PagePath: '/',
      elementHeight: 0,
      title: this.$route.query.title,
    };
  },
  mounted() {
    (this.Params.ListId = 'List' + this.$route.query.ListId),
      sessionStorage.setItem('ListId', JSON.stringify(this.Params));
    this.ongetLiteratureInfoNew();
    const elements = document.getElementsByClassName('Well_details');
    if (elements.length > 0) {
      const elementHeight = elements[0].getBoundingClientRect().height;
      this.elementHeight = elementHeight;
    }
    // 页面加载后允许缩放
    document
      .querySelector('meta[name="viewport"]')
      .setAttribute(
        'content',
        'width=device-width, initial-scale=1, maximum-scale=5, user-scalable=yes'
      );
  },
  beforeDestroy() {
    // 页面销毁前恢复禁止缩放
    document
      .querySelector('meta[name="viewport"]')
      .setAttribute(
        'content',
        'width=device-width, initial-scale=1, maximum-scale=1, user-scalable=no'
      );
    document.title = this.title;
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (from.path == '/list') {
        vm.PagePath = from.path;
        vm.Params.info = from.query.info;
        vm.Params.id = from.query.id;
      } else {
        vm.PagePath = '/';
      }
    });
  },
  methods: {
    ongetExtension(url) {
      // 获取最后一个 '.' 的位置
      const dotIndex = url.lastIndexOf('.');
      // 如果没有找到 '.' 或者 '.' 是在 URL 的开始位置，则返回空字符串
      if (dotIndex === -1 || dotIndex === 0) {
        return '';
      }
      if (url.substring(dotIndex) == '.mp4') {
        return true;
      }
    },
    async ongetLiteratureInfoNew() {
      let { data, code, msg } = await getLiteratureInfoNew({
        id: this.$route.query.ListId,
        event_id: this.$route.query.event_id,
      });
      if (code == 1) {
        this.details = data;
        this.details.url_arr = data.url_arr.split(',').map((item) => {
          return `${this.api}pdf_image/${item}`;
        });
        document.title = data.title;
      } else {
        this.$message.warning({
          message: msg,
        });
      }
    },
    onRetuen() {
      // 直接跳转到根路径并携带参数
      this.$router.push({
        path: this.PagePath,
        query: this.Params,
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.el-icon-picture-outline {
  font-size: 50px;
  color: #999;
}
.image-container {
  padding-top: 140px;
  min-width: 100%; /* 或者设置为一个固定宽度，如300px */
  min-height: 200px; /* 或者设置为一个固定高度，如200px */
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.main {
  position: relative;
  max-width: 750px;
  min-height: 100vh;
  margin: 0 auto;
  overflow: hidden;
  .main_image {
    width: 100%;
    height: 100%;
    .image-slot {
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .image_ {
      width: 100%;
    }
  }
  .Well_details {
    position: fixed;
    top: 0;
    max-width: 750px; /* 设置最大宽度 */
    width: 100%; /* 默认宽度为100%，如果超过最大宽度则会变为最大宽度 */
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    /* 响应式设计 */

    .Well_details_Sort {
      min-width: 4.75rem;
      min-height: 2.5rem;
      color: #fff;
      text-align: center;
      background: rgba(127, 127, 127);
      border-radius: 50px;
      display: flex;
      align-items: center;
      justify-content: center;
      margin: 0rem 1rem 1rem 0rem;
      margin-top: 20px;
      .Sort_img {
        width: 1rem;
        height: 1rem;

        img {
          width: 1rem;
          height: 1rem;
        }
      }

      &:hover {
        cursor: pointer;
      }
    }

    .Well_details_info {
      width: 100%;
      min-height: 8rem;
      padding: 0.5rem;
      box-sizing: border-box;
      background: #a3a3a3;
      box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 1);
      border-radius: 0.4rem 0.4rem 0px 0px;
      border: 0px solid #000000;
      .Well_details_info_head {
        display: flex;
        align-items: center;
        color: #fff;
        font-family: PingFang SC;
        font-weight: 400;
        font-size: 0.8rem;
        border-bottom: 1px solid #fff;
        padding: 0 0.8rem 0.8rem 0.5rem;
        box-sizing: border-box;
        .image {
          width: 0.9rem;
          margin: 0 0.8rem 0 0;
          img {
            width: 0.9rem;
          }
        }
        .title {
          line-height: 1.4rem;
        }
      }

      .a1362.Well_details_info_head {
        width: 100%;
        position: fixed;
        top: 0;
        z-index: 999999999;
        box-sizing: border-box;
        background: #00000060;
        box-shadow: 0px 0px 6px 0px rgba(0, 0, 0, 0.1);
        border-radius: 0.4rem 0.4rem 0px 0px;
        border: 0px solid #000000;
        width: 100%;
        margin-left: -0.5rem;
        padding: 0.6rem;
        max-width: 750px;
      }
      .Well_details_info_content {
        .View {
          color: #fff;
          font-size: 0.8rem;
          line-height: 1.4rem;
          margin: 0.8rem 0.8rem 0.8rem 0;
          display: flex;
          align-items: center;
          .image {
            width: 0.7rem;
            margin-right: 0.7rem;
            img {
              width: 0.7rem;
              height: 0.7rem;
            }
          }
          .title {
            flex-shrink: 0; /* 禁止收缩，确保宽度固定 */
          }
          .content {
            flex-grow: 1; /* 让.content 自动扩展，占据剩余空间 */
            padding-right: 0.8rem;
            box-sizing: border-box;
            white-space: normal;
          }
        }
      }
    }
  }
}

.x1362 {
      min-height: 6rem !important;
    }
</style>
